import { createEnvelopeSource } from './create-envelope-source';
import { DOC31_EDITION_ID } from './doc31-edition';

/**
 * LIFT purchases Six12 credited to one 31DOC edition
 * (`GET /analytics/purchases-31doc`). No-purchase entries are left out: they
 * have no basket and no amount. National only.
 */
export const purchases31docSource = createEnvelopeSource({
    label: '31DOC in-store purchases',
    endpoint: 'analytics/purchases-31doc',
    regionGrain: 'national',
    metrics: [
        { id: 'individuals', label: 'In-store individuals', type: 'scalar' },
        { id: 'transactions', label: 'Lift transactions', type: 'scalar' },
        {
            id: 'revenue',
            label: 'Revenue via LIFT',
            type: 'scalar',
            isCurrency: true,
        },
        {
            id: 'avgSpend',
            label: 'Avg. spent per transaction',
            type: 'ratio',
            isCurrency: true,
        },
        { id: 'itemsPerBasket', label: 'Items in basket', type: 'ratio' },
    ],
    forms: ['number'],
    staticParams: { campaignId: DOC31_EDITION_ID },
});
